
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Auth from "@/lib/common/auth";
import {
  AllOptionText,
  HeaderOption,
  UseRule
} from "@/lib/model/workerbuilder/exam-v3";

@Component({
  components: {}
})
export default class OptionDetail extends Vue {
  @Prop({ type: HeaderOption }) item!: HeaderOption; //配置项
  @Prop({ type: UseRule }) option?: UseRule; //多选
  @Prop({ type: Boolean }) hasPower?: boolean; //开通了权限
  AllOptionText = new AllOptionText().op; //全部文案
  defaultResList = [
    {
      title: "通过",
      text: "候选人在选择时命中通过规则，符合考察要求",
      status: 0
    },
    {
      title: "未通过",
      text: "候选人在选择时未命中通过规则，不符合考察要求",
      status: 1
    },
    {
      title: "未作答",
      text: "候选人未参加面试（包括中途退出）",
      status: 1
    }
  ];
  defaultResListVideo = [
    {
      title: "通过",
      text: "候选人得分符合要求",
      status: 0
    },
    {
      title: "未通过",
      text: "候选人得分未达到岗位要求",
      status: 1
    },
    {
      title: "未作答",
      text: "候选人未参加(包括中途退出)",
      status: 1
    }
  ];

  get getDefaultResList() {
    return this.item.type === "通用视频"
      ? this.defaultResListVideo
      : this.defaultResList;
  }

  show(item: any) {
    return (
      this.AllOptionText?.[item.type] || this.AllOptionText?.[item.optionName]
    );
  }
}
